import axios from "axios";
import { toast } from "react-hot-toast";
import { API_BASEURL, VERSION, APPID, DOMAIN_NAME } from "../Config";

class ApiCalling {
  constructor() {
    this.apiClient = axios.create({
      baseURL: API_BASEURL,
      headers: {
        "Content-Type": "application/json",
      },
    });

    this.apiClient.interceptors.request.use(
      (config) => {
        config.headers["appID"] = APPID;
        config.headers["domain"] = DOMAIN_NAME;
        config.headers["version"] = VERSION;
        return config;
      },
      (error) => {
        console.log("Request error:", error);
        return Promise.reject(error);
      },
    );

    this.apiClient.interceptors.response.use(
      (response) => {
        if (response.data?.msg?.includes("(redirectToLogin)Session")) {
          toast.error("Session expired, Please login");
          window.location.assign("/login");
        }
        return response.data;
      },
      (error) => {
        if (error.response?.status === 401) {
          console.log("Unauthorized, logging out...");
        }
        return Promise.reject(error);
      },
    );
  }

  request(method, url, data = null, params = null) {
    return this.apiClient({
      method,
      url,
      data,
      params,
    });
  }

  formDataRequest(method, url, formData, params = null) {
    return this.apiClient({
      method,
      url,
      data: formData,
      params,
    });
  }
}

export default new ApiCalling();
